
import { common as enCommon } from './en/common';
import { home as enHome } from './en/home';
import { about as enAbout } from './en/about';
import { contact as enContact } from './en/contact';
import { services as enServices } from './en/services';
import { common as skCommon } from './sk/common';
import { home as skHome } from './sk/home';
import { about as skAbout } from './sk/about';
import { contact as skContact } from './sk/contact';
import { services as skServices } from './sk/services';

export const resources = {
  en: {
    common: enCommon,
    home: enHome,
    about: enAbout,
    contact: enContact,
    services: enServices
  },
  sk: {
    common: skCommon,
    home: skHome,
    about: skAbout,
    contact: skContact,
    services: skServices
  }
};
